import {
  Avatar,
  Card,
  Chip,
  ClickAwayListener,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  Typography,
} from '@mui/material';
import { Box, Theme } from '@mui/system';
import React, { useState } from 'react';
import { useTranslate } from 'react-admin';
import { CategoryModel } from '../../../../config/types/models';
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

type IProps = {
  selected: CategoryModel[];
  allCategories: CategoryModel[];
  setCategories: (a: CategoryModel[]) => void;
};
function Categories({ selected, allCategories, setCategories }: IProps) {
  const t = useTranslate();
  const [displaySelect, setDisplaySelect] = useState(false);

  const onSelectCategory = (cat: CategoryModel) => {
    const selectedCat = allCategories.find((c) => c.id === cat.id);
    if (selectedCat) {
      if (selected.find((c) => c.id === selectedCat.id)) {
        setCategories(selected.filter((c) => c.id !== selectedCat.id));
      } else {
        setCategories([...selected, selectedCat]);
      }
    }
  };

  const onDelete = (sel: CategoryModel) => {
    setCategories(selected.filter((c) => c.id !== sel.id));
  };

  return (
    <Paper
      sx={{
        padding: 2,
        minHeight: 100,
      }}
    >
      <Box
        sx={{ cursor: 'pointer' }}
        onClick={() => setDisplaySelect(!displaySelect)}
      >
        <Typography>{t('categories')}</Typography>
        {selected.map((sel) => (
          <Chip
            key={sel.id}
            color='success'
            avatar={<Avatar src={sel.image} />}
            label={sel.name}
            sx={{ margin: 1 }}
            onDelete={() => onDelete(sel)}
          />
        ))}
      </Box>
      {displaySelect && (
        <ClickAwayListener onClickAway={() => setDisplaySelect(false)}>
          <Card
            sx={{
              position: 'absolute',
              height: 250,
              overflow: 'auto',
              zIndex: 999,
            }}
          >
            {allCategories.map((cat) => (
              <MenuItem
                onClick={() => onSelectCategory(cat)}
                key={cat.id}
                value={cat.id}
              >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Avatar src={cat.image} />
                  <Typography variant='caption'>{cat.name}</Typography>
                </Box>
              </MenuItem>
            ))}
          </Card>
        </ClickAwayListener>
      )}
    </Paper>
  );
}

export default Categories;
